export default "__VITE_ASSET__DoVkttH7__"